import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';

import { FontSizes } from '../../../../../core/config/mainTheme';
import { toCssValue } from '../../../../../core/utils/theme.utils';

interface OwnProps {
  text: string;
}

const FilterSubHeader: React.FC<OwnProps> = ({ text }) => {
  const classes = useStyles();

  return <Typography className={classes.root}>{text}</Typography>;
};

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: FontSizes.size.smallest,
    textTransform: 'uppercase',
    backgroundColor: theme.palette.secondary.main,
    padding: toCssValue([theme.spacing(3), theme.spacing(4)]),
    color: theme.palette.secondary.dark,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
}));

export default FilterSubHeader;
